import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { validateForm } from '@app/functions/validate-form';
import { TaskTemplate } from '@app/models/tasks/task-template.model';
import { TaskTemplateForm } from '@app/modules/forms/company/components';
import { AnalyticService, AuthService, NotifyService, TaskTemplateSubtasksService } from '@app/services';
import { getHelpCentreArticle } from '@app/types/translatable.type';

@Component({
    templateUrl: './task-templates-store.template.html',
})
export class TaskTemplatesStoreView {
    isLoading = true;
    isNew = true;
    title = 'employees.tasks-template.createTaskTemplate';
    taskTemplate: TaskTemplate = new TaskTemplate();
    events = AnalyticEvents;

    saveButtonCopy = 'employees.tasks-template.createTemplate';

    helpCentreArticle = getHelpCentreArticle('4409640751895');

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private auth: AuthService,
        private notify: NotifyService,
        private taskTemplateSubtasksService: TaskTemplateSubtasksService,
        public analyticService: AnalyticService
    ) {
        const taskTemplateOnEdit = this.route.snapshot.data?.models?.get('taskTemplate');

        if (taskTemplateOnEdit) {
            this.title = 'employees.tasks-template.editTaskTemplate';
            this.saveButtonCopy = 'employees.tasks-template.updateTaskTemplate';
            this.taskTemplate = taskTemplateOnEdit;
            this.isNew = false;
        }

        this.isLoading = false;
    }

    cancel(): void {
        this.analyticService.trackEvent(AnalyticEvents.PeopleTasksTaskTemplateEditCancel);
        this.router.navigate(['/employees', 'task-templates']);
    }

    async save(taskTemplateForm: TaskTemplateForm): Promise<void> {
        validateForm(taskTemplateForm.form);

        if (taskTemplateForm.form.invalid) {
            return;
        }

        this.resetToBeCompletedBy();

        this.isLoading = true;

        try {
            await taskTemplateForm.attachAndDetachEmployeeFilters();
            await this.taskTemplate.param('company', this.auth.company.id).save();

            await this.taskTemplateSubtasksService.onSaveSubTasks(this.taskTemplate, taskTemplateForm.subTasks);
            this.analyticService.trackEvent(
                this.isNew
                    ? AnalyticEvents.PeopleTasksTaskTemplatesCreateSave
                    : AnalyticEvents.PeopleTasksTaskTemplateEditSave
            );
            this.router.navigate(['/employees', 'task-templates', this.taskTemplate.id]);
        } catch (err) {
            this.notify.error(err);
        } finally {
            this.isLoading = false;
        }
    }

    private resetToBeCompletedBy(): void {
        if (this.taskTemplate.assigneeType === TaskTemplate.assigeeTypeSpecificEmployee) {
            this.taskTemplate.assigneeType = null;
            return;
        }
    }
}
